import {
  WorksheetImagesAndRemarksSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import { NamePrefixModifier, withInjectedProps } from '../../../Core/InjectedPropsContext';
import { PageSection } from '../../../Layout';
import qestIds from '../../QestIds';
import { EquipmentDetailsSection, InitialSeatingReadingSection, LabMoistureContent } from '../Sections';
import { LoadIncrementsSection, PreparationSection, ResultsPageSection } from './Sections';

let PlateLoadingWorksheet: WorksheetRootComponent = () => {
  return (
    <>
      <PageSection heading="Preparation">
        <NamePrefixModifier appendNamePrefix="Preparation">
          <PreparationSection />
        </NamePrefixModifier>
        <NamePrefixModifier appendNamePrefix="Equipment">
          <EquipmentDetailsSection />
        </NamePrefixModifier>
      </PageSection>

      <InitialSeatingReadingSection />
      <LoadIncrementsSection />
      <NamePrefixModifier appendNamePrefix="LabMoistureContent">
        <LabMoistureContent />
      </NamePrefixModifier>

      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>

      <ResultsPageSection />

      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

PlateLoadingWorksheet = withInjectedProps(PlateLoadingWorksheet);
PlateLoadingWorksheet.qestIds = [qestIds.plateLoading.BS_1377_9_Clause_4_1.rev1990];

export default PlateLoadingWorksheet;
export { PlateLoadingWorksheet };
